<template>
  <div class="dd-customer">
    <Header/>
    <Banner :image="bannerImage" title="我们的客户" description="让我们一起创造更多可能"/>
    <Section title="我们的客户">
      <div class="dd-customer__wrap">
        <span class="dd-customer__item" v-for="src in logos" :key="src" :style="{backgroundImage: `url(${src})`}"></span>
      </div>
    </Section>
    <Footer/>
  </div>
</template>

<script>
export default {
  data () {
    return {
      bannerImage: require('../assets/customer.jpg'),
      logos: [
        require('@/assets/logos/cctv_news@2x.png'),
        require('@/assets/logos/cctv@2x.png'),
        require('@/assets/logos/people@2x.png'),
        require('@/assets/logos/xhs@2x.png')
      ]
    }
  }
}
</script>

<style lang="scss">
.dd-customer {
  &__wrap {
    margin-left: -25px;
    margin-top: -40px;
    text-align: center;
  }
  &__item {
    display: inline-block;
    width: 325px;
    height: 160px;
    background: center no-repeat;
    background-size: 55%;
    margin-left: 25px;
    margin-top: 40px;
  }
  @include media-tablet {
    &__wrap {
      margin-top: 0;
      margin-left: 0;
    }
    &__item {
      display: block;
      width: auto;
      max-width: 330px;
      margin: 30px auto 0 !important;
    }
  }
}
</style>
